<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTableSh',title:'销售样表（上海直销）'},{title:'新增销售样表'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增销售样表</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiaos">
                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="prodseries">
                                                <el-select v-model="f.prodseries" :v="f.prodseries" placeholder="请选择">
                                                    <el-option v-for="(item,index) in LevelName"
                                                               :key="index+1"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="promodel">
                                                <el-input placeholder="请输入" v-model="f.promodel"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="prodcode">
                                                <el-input placeholder="请输入" v-model="f.prodcode"></el-input>
                                            </el-form-item>
                                            <el-form-item label="状态" class="h-elformWrap-2" prop="prodstatus">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"
                                                          :clearable="true"/>
                                            </el-form-item>
                                            <el-form-item label="型号属性" class="h-elformWrap-2" prop="protype">
                                                <el-select v-model="f.protype" placeholder="请选择">
                                                    <el-option value="自产">自产</el-option>
                                                    <el-option value="OEM">OEM</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="采购价格" class="h-elformWrap-2" prop="cgprice">
                                                <el-input placeholder="请输入" v-model="f.cgprice" maxlength="8"></el-input>
                                            </el-form-item>
                                            <el-form-item label="币种" class="h-elformWrap-2" prop="currency">
                                                <brselect category="YLCurrency" :v="f.currency" v-model="f.currency"/>
                                            </el-form-item>
                                            <el-form-item label="供应商编码" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="f.supplierId"></el-input>
                                            </el-form-item>
                                            <el-form-item label="供应商名称" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="f.supplierName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="品牌" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="f.pinpai"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveS">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                //带线表单
                f: {
                    procategory: ''
                },
                LevelName: [],
                ProCategory: [],
                rules: {
                    prodseries: [{required: true, message: '请选择产品大类', trigger: 'change'}],
                    promodel: [{required: true, message: '请填写产品型号', trigger: 'blur'}],
                    prodcode: [{required: true, message: '请填写产品编码', trigger: 'blur'}],
                    prodstatus: [{required: true, message: '请选择状态', trigger: 'change'}],
                    protype: [{required: true, message: '请选择型号属性', trigger: 'change'}],
                    cgprice: [
                        {required: true, message: '请填写采购价格', trigger: 'blur'},
                        { validator: (rule, value, callback) => {
                                if (/^\d+.\d+$/.test(value) == false) {
                                    callback(new Error("只能写浮点数"));
                                } else {
                                    callback();
                                }
                            },trigger: 'blur'
                        }

                    ],
                },
            }
        },
        created() {
            this.showLevelName();
        },
        methods: {
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //返回
            backS() {
                this.$router.push({path: "/chanp/salesTableSh"});
            },
            //保存
            saveS() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该信息获取?", () => {
                        for (var i = 0; i < this.LevelName.length; i++) {
                            if (this.LevelName[i].id == this.f.prodseries) {
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                        ss.salesListSh.saveS(this.f).then(rd => {
                            this.$router.push({path: "/chanp/salesTableSh"});
                        })
                    });
                }
            }
        }
    }
</script>
<style>
    .Yangbiaos .el-form-item__label {
        width: 34%;
        text-align: right;
    }

    .Yangbiaos .el-form-item__content {
        width: 66%;
    }

    .Yangbiaos .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }

    .Yangbiaos .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiaos .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .Yangbiaos .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }

    .Yangbiaos.el-form-item__content .el-select {
        width: 100%;
    }
</style>
